import React from "react";
import "./Addons.css";

const Addons = () => {
  return (
    <div>
      <h1>Add-ons</h1>
      <p>
        Custom software packages to add features to upgrade your parking lot.
      </p>

      <div className="addons-box">
        <h2>No Results Found</h2>
        <p>There are currently no Addons available in your location.</p>
        <a href="#">Learn more</a>
      </div>
    </div>
  );
};

export default Addons;
